var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input',{ref:"inputRef",class:_vm.styleClass,attrs:{"label":_vm.label,"icon-pack":_vm.iconPack || 'feather',"icon":_vm.icon || 'icon-dollar-sign',"name":_vm.name,"disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }